// Styles
import './_main-product.scss';